var _path, _g, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEscudoIcono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.902832H20.625V26.8541H0.5V0.902832Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_265)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08465 6.28939V16.2188C2.08465 18.3203 3.1912 20.2834 5.04508 21.4698L10.8205 25.1663L16.233 21.4935C17.9908 20.3006 19.0404 18.3752 19.0404 16.3431V6.25902C17.3372 6.13235 13.3103 5.5521 10.8373 2.90436C9.70537 4.10713 7.05821 6.15463 2.08465 6.28939ZM10.8336 26.8541C10.6809 26.8541 10.5281 26.8117 10.395 26.7265L4.16782 22.7408C1.87119 21.2708 0.5 18.8326 0.5 16.2188V5.53134C0.5 5.32699 0.585095 5.13118 0.736112 4.98788C0.884593 4.84701 1.08442 4.76826 1.29232 4.76826C1.29613 4.76826 1.30009 4.76826 1.30405 4.76842C7.8583 4.86273 10.0597 1.42383 10.1503 1.27747C10.289 1.05297 10.5389 0.910428 10.81 0.903103C11.0823 0.896235 11.3387 1.02031 11.4903 1.23687C13.9283 4.71561 19.7748 4.76811 19.8336 4.76826C20.2705 4.76918 20.625 5.11058 20.625 5.53134V16.3431C20.625 18.8709 19.3243 21.2626 17.1458 22.741L11.29 26.7148C11.1534 26.8076 10.9935 26.8541 10.8336 26.8541Z",
    fill: "#1A3992"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70141 18.2141C9.48685 18.2141 9.28148 18.1305 9.13204 17.9817L5.59797 14.4646C5.29371 14.1617 5.3018 13.6787 5.61635 13.3855C5.93106 13.0925 6.43244 13.1004 6.73669 13.4034L9.67684 16.3292L15.7061 9.79642C15.9969 9.48142 16.4975 9.45303 16.8247 9.73308C17.1518 10.0131 17.1811 10.4954 16.8905 10.8104L10.2936 17.958C10.1472 18.1168 9.93863 18.2094 9.71805 18.214C9.7125 18.2141 9.70695 18.2141 9.70141 18.2141Z",
    fill: "#1A3992"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscudoIcono);
export default __webpack_public_path__ + "static/media/EscudoIcono.427d0a9c22bc51ab0043c753cd1623ba.svg";
export { ForwardRef as ReactComponent };